import React from 'react';
import { connect } from 'react-redux';
import { PostersGrid, SnapshotBackground } from '../../components';
import { setCurrentSection } from '../../actions/globalConfig';

class PearlsOfThePlanetView extends React.Component {

    constructor(props) {
      super(props);
      this.props.dispatch(setCurrentSection('Pearls Of The Planet'));
    }

    render() {
        const {backgroundImage} = this.props;
        return (
          <div>
          <div className="container-fluid content mb-20 mt-60">
            <div className="bg-fff-50 video-player container-rounded">
              <PostersGrid />
            </div>
          </div>
            <SnapshotBackground img={backgroundImage} blurRadius={300} />
          </div>
        );
    }

}

const mapStateToProps = (state) => {
  let backgroundImage = state.globalConfig.backgroundImage;
  backgroundImage = backgroundImage.replace('http://files', 'https://files');
    return {
      backgroundImage
    };
};

export default connect(mapStateToProps)(PearlsOfThePlanetView);
